
import { Button } from "primereact/button"
import { Calendar } from "primereact/calendar"

import { Dropdown } from "primereact/dropdown"
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import { handleLoader } from "redux/counterSlice"
import { getCategories, getInventoryData, getInventoryGraphData, getProducts, getUserPreference } from "services/forecastService"
import { formateDate } from "utils/formatDate"


import gridViewIconDark from "../../assets/icons/grid-view-icon-dark.svg"
import analyticsIconDark from "../../assets/icons/analytics-icon-dark.svg"

import gridViewIconLight from "../../assets/icons/grid-view-icon-light.svg"
import analyticsIconLight from "../../assets/icons/analytics-icon-light.svg"


import { capitalizeHeader } from "../../utils/helper"
import AnalyticsComponent from "components/forecast/AnalyticsComponent"

import dnIcon from "../../assets/icons/dn-icon.svg"
import {
	FilterData,
	CategoryProductList,
	InventoryData,
	GraphForecastData,
	ToggleViewState,
	Product,
	LastMemory,
} from "./forecastTypes"
import { shortenString } from "utils/helper"
import DataTableComponent from "components/forecast/DataTableComponent"
import { Toast } from "primereact/toast"



const Forecast = () => {
	const dropdownRef: any = useRef(null)
	const showCategory = useRef<MultiSelect>(null)
	const toastRef = useRef<Toast>(null);
	const categoryRef = useRef<MultiSelect>(null)
	const productRef = useRef<MultiSelect>(null)
	const calenderRef = useRef<Calendar>(null)
	const [SearchByName, setSearchByName] = useState<boolean>(true)
	const [downloadCsv, setDownloadCsv] = useState<boolean>(false)
	const [searchParams] = useSearchParams()
	const firstForecast: number | null = searchParams.get("first") !== null ? Number(searchParams.get("first")) : 0
	
	const [data, setData] = useState<InventoryData>()
	const [first, setFirst] = useState<number>(firstForecast)

	const [graphData, setGraphData] = useState<GraphForecastData>()

	const [last_Memory, setLastMemory] = useState<LastMemory>({
		last_categories: [],
		last_products: []
	})


	const [dates, setDates] = useState<Date[]>(() => {
		const today = new Date();
		const nextYear = new Date();
		nextYear.setDate(today.getDate() + 365);
		return [today, nextYear];
	})
	

	const [filterData, setFilterData] = useState<FilterData>({
		client_env: localStorage.getItem("clientName") as string,

		category_id: [],
		product_id: [],
		forecast_range_start_date: formateDate(new Date()),
		forecast_range_end_date: "",
		forecast_by: "",
		page: 1,
		size_limit: 50,

	})



	const [categoryList, setCategoryList] = useState<CategoryProductList[]>([])
	const[tempCategoryList, setTempCategoryList] = useState<CategoryProductList[]>([])
	const [productList, setProductList] = useState<Product[]>([])
	const [tempProductList, setTempProductList] =  useState<Product[]>([])


	const [toggleView, setToggleView] = useState<ToggleViewState>({
		chartView: true,
		gridView: false
	});


	

	const dispatch = useDispatch()

	const foreCastByList = ["Day", "Week", "Month"]

	const handleDateSelection = (e: any) => {
		const selectedDatesArray = e.value
		if (selectedDatesArray?.length === 2) {
			// Update the selected dates when a valid range is selected
			setDates(selectedDatesArray)
			setFilterData({
				...filterData,
				forecast_range_start_date: formateDate(selectedDatesArray[0]),
				forecast_range_end_date: formateDate(selectedDatesArray[1]),
			})
		} else {
			// Clear the selection when less than two dates are selected
			setDates([])
		}
	}

	
	const fetchCategories = async (updatedFilter: any) => {


let updatedValue  
		try {
			dispatch(handleLoader(true))
			const { result, error } = await getCategories()
			if (error) {
				throw error
			}
		
			const onlyCategories = result.map((item: any) => item.category)
			setCategoryList(result)
			setTempCategoryList(result)
			fetchProducts([onlyCategories[0]])
			
			
			updatedValue = { ...updatedFilter, category_id: [onlyCategories[0]], product_id: ["HKO-25147-6C"]}
			setLastMemory({ ...last_Memory, last_categories: updatedValue.category_id, last_products: updatedValue.product_id })
			setFilterData(updatedValue)

		} catch (error: any) {
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
		return updatedValue
	}

	const fetchProducts = async (categoriesName: any) => {

		const { result, error } = await getProducts(categoriesName)
		if (error) throw error

		let allProducts: any[] = result.data.flatMap((category: any) => category.products);

		setProductList(allProducts)
		setTempProductList(allProducts)
		return allProducts

	}



	const fetchGraphData = async (filter: any) => {

		try {

			dispatch(handleLoader(true))
		
			const { result, error } = await getInventoryGraphData(filter)
			if (error) {
				throw error
			}

			setGraphData(result)
			dispatch(handleLoader(false))
		} catch (error: any) {
			dispatch(handleLoader(false))
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
	}


	const fetchData = async (filterData: FilterData) => {
		try {
			dispatch(handleLoader(true))
			const { result, error } = await getInventoryData(filterData)
			if (error) {
				throw error
			}
			setData(result)
			dispatch(handleLoader(false))
		} catch (error: any) {
			dispatch(handleLoader(false))
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
	}


	const handleSubmit = async (filterData: FilterData) => {
		if (filterData.category_id?.length === 0) return showCategoryError()
		if (filterData.product_id?.length === 0) return showProductError()
		productRef.current?.hide()

		try {
		
			toggleView.gridView &&  await fetchData(filterData)
			toggleView.chartView  && await fetchGraphData(filterData)
			dispatch(handleLoader(false))
	
		} catch (error: any) {
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}
	}

	const fetchUserPreference= async () => {

	let updatedFilter
		const userdata = {
			client_env: localStorage.getItem("clientName") as string,
			user_id: localStorage.getItem("username") as string
		}

		try {
			dispatch(handleLoader(true))
			const { result, error } = await getUserPreference(userdata)
			if (error) {
				throw error
			}
			

			 updatedFilter = {...filterData, forecast_range_end_date: result.forecast_till_date.split("T")[0],
				forecast_by: capitalizeHeader(result.forecast_by),} // backend data coming in lowercase

			
			setFilterData(updatedFilter)
			dispatch(handleLoader(false))
		} catch (error: any) {
			dispatch(handleLoader(false))
			toast.error(error, {
				style: {
					backgroundColor: '#F1F1F1', // Grey background
				}
			})
		}

		return updatedFilter
	}


useEffect(() => {
		
	async function updateGraphData() {
		try {
		  const updatedFilter = await fetchUserPreference();
		  const updatedValue = await fetchCategories(updatedFilter);

		//   dispatch(handleLoader(false))
		  await fetchGraphData(updatedValue);
		} 
		catch(error){
		  console.error("Error occurred:", error);
		}
	  }
	  
	  updateGraphData();
	  

	}, [])




	useEffect(() => {

		graphData && handleSubmit(filterData) || data && handleSubmit(filterData)
		

	}, [filterData.forecast_by])


	useEffect(() => {
		data && fetchData(filterData)
	}, [filterData.page])


	
	function toggleForecastView(name: string) {

		if (name === "chart" && toggleView.chartView === false) {

			setToggleView(prev => { return { ...prev, chartView: true, gridView: false } })
		}

		else if (name === "grid" && toggleView.gridView === false) {
			setToggleView(prev => { return { ...prev, gridView: true, chartView: false } })
		}

	}
	

	// const onCategoryChangeHandler = (e: MultiSelectChangeEvent) => {
	// 	const productList = categoryList.filter((item) => (e.value?.includes(item.category_name) && item.products))
	// 		.flatMap((subItem) => subItem.products) ?? []

	// 	setProductList(productList)
	

	// 	setFilterData((prevArray) => {
	// 		return {
	// 			...prevArray, category_id: e.value, product_id: e.value.length <= 0 ? []
	// 				: filterData.product_id?.filter((product) => productList.find((item) => item.product_id === product) && product),
	// 		}
	// 	})
	// }

	const showCategoryError = () => {
		toastRef.current?.show({ severity: 'info', summary: 'Info', detail: 'Please select atleast one category', life: 2000 });
	}
	const showProductError = () => {
		toastRef.current?.show({ severity: 'info', summary: 'Info', detail: 'Please select atleast one product', life: 2000 });
	}

	// const showRegionError = () => {
	// 	toastRef.current?.show({ severity: 'info', summary: 'Info', detail: 'Please select atleast one region', life: 2000 });
	// }

	const categoryApply = async () => {
		if (filterData.category_id?.length === 0) return showCategoryError()

		try {

			categoryRef.current?.hide()
			dispatch(handleLoader(true))

			const { result, error } = await getProducts(filterData.category_id)
			if (error) throw error


			const payload = result.data.map((item: any) => item.products[0].product_id)
			const tempFilterData = { ...filterData, product_id: payload }

			toggleView.chartView && await fetchGraphData(tempFilterData)
			toggleView.gridView && await fetchData(tempFilterData)


			setFilterData(tempFilterData)
		


			setLastMemory({ ...last_Memory, last_categories: tempFilterData.category_id!, last_products: tempFilterData.product_id! })

			let allProducts: any[] = result.data.flatMap((category: any) => category.products);
			setProductList(allProducts)
			dispatch(handleLoader(false))
			productList && productRef.current?.show()

		} catch (error: any) {
			toast.error(error)
		}

	}

	const onProductChangeHandler = (e: MultiSelectChangeEvent) => {

		setFilterData({ ...filterData, product_id: e.value });
	}

	//for selection to come on top


useEffect(() => {




	if (toggleView.chartView && graphData) {

		if (filterData.category_id?.length === 0 || filterData.product_id?.length === 0) {

			const tempFilterData = { ...filterData, category_id: last_Memory?.last_categories, product_id: last_Memory?.last_products }
			setFilterData(tempFilterData)
			fetchGraphData(tempFilterData)
		}
		else {
			fetchGraphData(filterData)
		}

	}

	if (toggleView.gridView) {


		if (filterData.category_id?.length === 0 || filterData.product_id?.length === 0) {


			const tempFilterData = { ...filterData, category_id: last_Memory?.last_categories, product_id: last_Memory?.last_products }
			

			setFilterData(tempFilterData)
			fetchData(tempFilterData)
		}


		else {
			fetchData(filterData)
		}



	}

}, [toggleView.chartView, toggleView.gridView])






useEffect(()=>{


	const tempList = categoryList.filter((item) => (filterData.category_id?.includes(item.category)))

			const newItems = [
				...tempList,
				...categoryList.filter((item: CategoryProductList) => filterData.category_id && !filterData.category_id.includes(item.category)) // Unselected items
			];
			setTempCategoryList(newItems);
	
	
	}, [filterData.category_id])


	useEffect(()=>{


		const tempList = productList.filter((item) => (filterData.product_id?.includes(item.product_id)))
	
				const newItems = [
					...tempList,
					...productList.filter((item: Product) => filterData.product_id && !filterData.product_id.includes(item.product_id)) // Unselected items
				];
				setTempProductList(newItems);
		
		
		}, [filterData.product_id])



	useEffect(() => {

		const tempArray = filterData.product_id?.filter(item => {
			return productList?.some(productItem => productItem.product_id === item);
		});

		setFilterData(prev => ({ ...prev, product_id: tempArray }))

	}, [productList])




// function firstProduct() {
// 	const firstProductList: number[] = categoryList
// 		.map((item) => {
// 			if (filterData.category_id?.includes(item.category) && item.products) {
// 				return item.products[0]?.product_id ?? null; // Use nullish coalescing to ensure null is returned if undefined
// 			}
// 			return null;
// 		})
// 		.filter((productId): productId is number => productId !== null && productId !== undefined);

// 	const data = { ...filterData, product_id: firstProductList };

// 	setFilterData(data);
// 	return data
// }


const categoryFooterTemplate = () => {
	return (
		<div className="filter-action-btn">
			<Button label="Clear" className="outline-icon-btn mr-2" onClick={() => {
				setFilterData((prevArray) => { return { ...prevArray, category_id: [] } })
			}} />
			<Button label="Apply" className="outline-active-btn" onClick={categoryApply} />
		</div>
	);
};

const productFooterTemplate = () => {

	return (
		<div className="filter-action-btn">
			<Button label="Clear" className="outline-icon-btn mr-2" onClick={() => {
				setFilterData(prev => { return { ...prev, product_id: [] } })
			}} />
			<Button label="Apply" className="outline-active-btn" onClick={() => {

				handleSubmit(filterData)
			}} />
		</div>
	);
}

	const productItemTemplate = (option: any) => {

	
		const productLabel = SearchByName ?  option?.product_name : option?.product_id
		const shortStringLabel = shortenString(SearchByName ?  option?.product_name : option?.product_id, 33)
				return (
					<div className="flex align-items-center">
						<div title={productLabel}>{shortStringLabel} </div>
					</div>
				);
			};
		
		



	const calenderFooterTemplate = () =>{
		return (
			<div className="filter-action-btn text-center">
				<Button label="Apply" className="outline-active-btn" onClick={()=>{
					 calenderRef.current?.hide()  
					 handleSubmit(filterData)
					}
					 } />
			</div>
		);
	
	}



	return (<>
	<Toast ref={toastRef} />
		<div className='p-4 content-wrapper w-100 '>
			<section className="user-management-section inventoryForcast-section">
				<div className="d-flex align-items-center justify-content-end flex-wrap mb-3 table-top-row">
					<div className="d-flex justify-content-between align-items-center table-right-row w-100">
						<div className="d-flex align-items-center flex-wrap table-right-first mb-4">
							<div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
								<span className="outer-box-label">Category: </span>
								<MultiSelect
									value={filterData.category_id}
									className="outline-select multi-select"
									style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
									onChange={(e: MultiSelectChangeEvent) => {
										setFilterData((prevArray) => { return { ...prevArray, category_id: e.value } })
										
									}}
									filter
									name={"categoryId"}
									id={"categoryId"}
									placeholder="Select category"
									options={tempCategoryList}
									maxSelectedLabels={0}
									optionLabel="category"
									optionValue="category"
									panelFooterTemplate={()=>categoryFooterTemplate()}
									// ref={showCategory}
									resetFilterOnHide
									closeIcon="false"
									ref={categoryRef}
								/>
							</div>
							<div className="d-flex align-items-center mr-3 mt-1 mb-1 pro-tab-wrap">
								<span className={`pro-tab ${!SearchByName ? 'active' : ""}`} onClick={()=>setSearchByName(false)}>Product Id</span>
								{/* <InputSwitch checked={SearchByName} onChange={(e) => setSearchByName(e.value)} /> */}
								<span className={`pro-tab ${SearchByName ? 'active' : ""}`} onClick={()=>setSearchByName(true)}>Product Name</span>
							</div>
							<div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
								<span className="outer-box-label">Product: </span>
								<MultiSelect
									value={filterData.product_id}
									className="outline-select multi-select product-select"
									style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
									onChange={(e: MultiSelectChangeEvent) => onProductChangeHandler(e)}
									name={"productId"}
									id={"productId"}
									showSelectAll={false}
									filter
									placeholder="Select product"
									options={tempProductList}
									optionLabel="product_name"
									optionValue="product_id"
									maxSelectedLabels={0}
									panelFooterTemplate={productFooterTemplate}
									disabled={filterData.category_id?.length === 0 ? true : false}
									// ref={showCategory}
									virtualScrollerOptions={{ itemSize: 24, className:"virtual-multi-select"}}
									itemTemplate={productItemTemplate}
									resetFilterOnHide
									closeIcon="false"
									ref={productRef}
					
								/>
							</div>
							<div className="d-flex align-items-center mr-3 mt-1 mb-1 outer-box-border">
								<span className="outer-box-label">Forecast by: </span>
								<Dropdown
									ref={dropdownRef}
									value={filterData?.forecast_by}
									style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }}
									onChange={(e) => {
										setFilterData({ ...filterData, forecast_by: e.value })

									}}
									name="forecastBy"
									id="forecastBy"
									options={foreCastByList}
									placeholder="Select an interval"
									optionLabel=""
									className="outline-select multi-select"
								// onShow={() => setDropdownOpenEmotion(true)}
								// onHide={() => setDropdownOpenEmotion(false)}
								// dropdownIcon={customDropdownIcon(isDropdownOpenEmotion)}
								/>
							</div>
							<div className="d-flex align-items-center mr-3 mt-1 mb-1 voice-filter-col filter-calendar">
								<Calendar
									minDate={new Date()}
									name="duration"
									value={dates}
									onChange={handleDateSelection}
									selectionMode="range"
									showIcon
									readOnlyInput
									
									dateFormat="dd/mm/yy"
									view = "date"  
									footerTemplate={calenderFooterTemplate}
									ref={calenderRef}
								/>
							</div>
						</div>
						<div className="d-flex align-items-center justify-content-end flex-wrap mb-4">
							<div className="flex gap-3">
								<button className="download-btn" onClick={()=>setDownloadCsv(true)}>
									<img src={dnIcon} alt="download-icon" />
									Download
								</button>
								<div className="tab-view">
									<span onClick={() => toggleForecastView("chart")} className={toggleView.chartView ? "active" : ""}>
										<img src={toggleView.chartView ? analyticsIconDark : analyticsIconLight} alt="analytics image"  />
										Graph
									</span>
									<span onClick={() => toggleForecastView("grid")} className={toggleView.gridView ? "active" : ""}>
										<img src={toggleView.gridView ? gridViewIconDark : gridViewIconLight} alt="grid image" />
										Grid
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</section>

			{(toggleView.chartView) ?

				(graphData && <AnalyticsComponent graphData={graphData}
					downloadCsv={downloadCsv}
					setDownloadCsv = {setDownloadCsv}
					currentUIView={toggleView}
					filterData={filterData} />)
				: (data &&
					(<div className="datatable-wrapper">
						<DataTableComponent data={data}
								first={first}
								setFirst={setFirst}
								setFilter={setFilterData}
								filterData={filterData}
								downloadCsv={downloadCsv}
								setDownloadCsv = {setDownloadCsv}
								currentUIView={toggleView}
						/>
					</div>
					))
			}

		</div>
		</>
	)
}

export default Forecast



	// function generateLargeDataSet(item : any, itemType: string) {
	// 	const groups = [`Total Count: ${item?.length ?? 0}`];
	// 	const flatData: any = [];

	// 	const keyName = itemType==="product"? "product_name" : "category_name"
	// 	flatData.push({ [keyName]: groups[0], hideCheckbox: true });
	
	// 	flatData.push(...item)
	

	
	// 	return flatData;
	//   }
